// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"602":"1bf9472b","628":"95a2191f","754":"ef5be211"}[chunkId] + ".chunk.css";
};